module.exports = __webpack_public_path__ + "img/album01_12.47259d33.jpg";